import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-overlay-side-panel-footer',
  template: `
    <!-- <div class="side-panel-footer"> -->
      <ng-content></ng-content>
    <!-- </div> -->
  `,
  styles: [
    `
      :host {
        display: flex;
        justify-content: space-around;
        padding: 2rem 4rem 4rem 4rem;

        .side-panel-footer {
          width: 100%;
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OverlaySidePanelFooterComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
